import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label } from 'reactstrap';
import useNotificationDetails from '../Hooks/useNotificationDetails';

const ModalLeerNotificacion = ({ isOpen, toggle, selectedNotificacionId }) => {
    const { notification, loading, error } = useNotificationDetails(isOpen ? selectedNotificacionId : null);

    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date);
        return _date.toLocaleString('es-CL');
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="ri-eye-line me-2"></i>
                Leer Notificación
            </ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="text-center">Cargando notificación...</div>
                ) : error ? (
                    <div className="text-center text-danger">{error}</div>
                ) : notification ? (
                    <>
                        <FormGroup>
                            <Label for="subject">Asunto</Label>
                            <div className="form-control" readOnly style={{ backgroundColor: '#f8f9fa' }}>
                                {notification.subject}
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label for="status">Estado</Label>
                            <div className="form-control" readOnly style={{ backgroundColor: '#f8f9fa' }}>
                                {notification.status}
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label for="created_at">Fecha de Creación</Label>
                            <div className="form-control" readOnly style={{ backgroundColor: '#f8f9fa' }}>
                                {formatDate(notification.created_at)}
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label for="recipients">Destinatarios</Label>
                            <div className="form-control" readOnly style={{ backgroundColor: '#f8f9fa', minHeight: '60px' }}>
                                {notification.recipients ? notification.recipients.map(r => r.recipient).join(', ') : ''}
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label for="body_plain">Contenido</Label>
                            {notification.body_html ? (
                                <div className="form-control" readOnly style={{ backgroundColor: '#f8f9fa', minHeight: '200px', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: notification.body_html }} />
                            ) : (
                                <pre className="form-control" readOnly style={{ backgroundColor: '#f8f9fa', whiteSpace: 'pre-wrap', minHeight: '200px' }}>
                                    {notification.body_plain}
                                </pre>
                            )}
                        </FormGroup>
                    </>
                ) : (
                    <div className="text-center">No se pudo cargar la notificación.</div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="light" onClick={toggle}>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerNotificacion;